<div class="container">
  <div class="contato">
    <mat-card-title class="titulo"
      >Dúvidas e/ou sugestões? Envie pra gente!</mat-card-title
    >
    <div class="linha"></div>
    <form>
      <mat-form-field appearance="outline">
        <mat-label>Nome completo</mat-label>
        <input
          matInput
          placeholder="Insira seu nome completo"
          type="text"
          required
          [(ngModel)]="contato.nome"
          name="nome"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>E-mail</mat-label>
        <input
          matInput
          placeholder="Insira seu e-mail"
          type="text"
          required
          [(ngModel)]="contato.email"
          name="email"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Mensagem</mat-label>
        <textarea
          matInput
          placeholder="Escreva sua dúvida e/ou sugestão"
          rows="10"
          required
          [(ngModel)]="contato.mensagem"
          name="mensagem"
        ></textarea>
      </mat-form-field>
    </form>
    <div class="centralizar">
      <button
        [disabled]="enviarDesabilitado"
        class="botao"
        mat-raised-button
        color="white"
        (click)="enviarMensagem()"
      >
        Enviar
      </button>
    </div>
  </div>
</div>
